<app-header extraClass="nav-down text-gray-innerMenu"></app-header>

<section class="information-wrp mt-110 mb-5">
  <div class="container">
    <h4>Privacy Policy</h4>
    <div class="uk-flex information-wrp-inner">

      <div class="w-30">
        <div class="left-panel privacy-policy">
          <ul>

            <li>
              <a [routerLink]="['/p/terms-and-conditions']">
                <span>Terms & Conditions</span>
                <img src="assets/images/icons/arrow-white-right.png" alt="">
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!--w-30-->

      <div class="w-70">
        <div class="information-wrp-details">

          <div class="info privacy-policy">

            <h4>1. Introduction</h4>
            <p>Welcome to THINGS2DO.com a portal run by Xplorebee Private Limited (“THINGS2DO”). THINGS2DO is committed
              to respecting your online privacy and recognizes your need for appropriate protection and management of
              any information you share with THINGS2DO on THINGS2DO.com (the "website/application").</p>
            <h4>2. Scope</h4>
            <p>This privacy policy (“Policy”) is an electronic record in the form of an electronic contract formed under
              the Information Technology Act, 2000 and the rules made thereunder. This Policy does not require any
              physical, electronic or digital signature. This Policy is a legally binding document between you and
              THINGS2DO. The terms of this Policy will be effective upon your acceptance of the same by use of the
              website/application and will govern the relationship between you and THINGS2DO for your use of the
              website/application.</p>
            <h4>3. Consent</h4>
            <p>By mere use of the website/application, you expressly consent to THINGS2DO’s use and disclosure of your
              Personal Information in accordance with this Policy. If you do not agree with the terms of this Policy,
              please do not use this website/application. This Policy shall be deemed to be incorporated into the Terms
              of Use of the website/application and shall be read in addition to the Terms of Use.</p>
            <h4>4. What Information Is Collected</h4>

            <ul>
              <li>The Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data
                or Information) Rules, 2011 defines “Personal Information” as any information that relates to a natural
                person, which, either directly or indirectly, in combination with other information available or likely
                to be available with a body corporate, is capable of identifying such person.
              </li>
              <li>For the purpose of this Policy, the term “Personal Information” shall mean any information you provide
                to THINGS2DO and shall include, without limitation your name, phone number, your email address, your
                financial information such as bank account or credit card or debit card or other payment details, your
                email ID and password.
              </li>
              <li>For the purpose of this Policy, the term “Non-Personal Information” shall mean information that does
                not specifically identify an individual but includes information from you, such as the type of internet
                browser you use, mobile device you use, your computer or your mobile device’s unique device ID, the URL
                of the previous website/application you visited, your computer’s operating system, your Internet Service
                Provider (ISP) and your Internet Protocol (IP) address. THINGS2DO may also collect Non-Personal
                Information that you voluntarily provide, such as information included in response to a questionnaire,
                or a survey conducted by THINGS2DO.
              </li>
            </ul>

            <h4>5.Collection of Information</h4>
            <ul>
              <li>THINGS2DO may collect information from you when you register on the website/application through your
                Facebook account or email account, when you use the features on the website/application, when you
                participate in surveys conducted by THINGS2DO on the website/application and when you carry out
                transactions on the website/application.
              </li>
              <li>THINGS2DO may use cookies to monitor the website/application usage including, without limitation, to
                provide useful features to simplify your experience when you return to the website/application, like
                remembering your login ID and certain Personal Information and to deliver relevant content based on your
                preferences, usage patterns and location.
              </li>
              <li>You may be also required to provide your credit/debit card details. THINGS2DO will use this
                information only for billing purposes. For your convenience and if permitted by you, THINGS2DO will save
                the billing information in the event you would like to carry out any other transaction on the
                website/application again.
              </li>
              <li>When you access the website/application through a mobile device, you will have the option of
                downloading the mobile application of THINGS2DO. In case you download the mobile application you will be
                asked if you would want to share your contact list with THINGS2DO. You may choose not to share your
                contact list with THINGS2DO, however in case you chose to share your contact list with THINGS2DO,
                THINGS2DO shall have access to and store your contact list.
              </li>
              <li>You may use the website/application without providing THINGS2DO any Personal Information about
                yourself. However, you may not be able to access certain services of the website/application in case you
                choose to do so.
              </li>
            </ul>
            <h4>6. Use of Information</h4>
            <p>THINGS2DO uses your Personal and Non-Personal Information for certain purposes including but not limited
              to:</p>
            <ul>
              <li>Service-related Purpose</li>
              <li>enabling you to use the website/application;</li>
              <li>providing you with information about products and services available on the website/application;</li>
              <li>resolving any glitches on the website/application including addressing any technical problems;</li>
              <li>improving your experience of navigating through the website/application and carrying out transactions
                on the website/application; and
              </li>
              <li>improving the services and content on the website/application.</li>
              <li>Internal Business Purpose</li>
            </ul>
            <p>THINGS2DO may use your Non-Personal Information for internal business purposes, such as data analysis,
              research, developing new features, enhancing, and improving existing services and in identifying usage
              trends. This information helps THINGS2DO to constantly improve, personalize and customize the products and
              services it provides to you.
            </p>
            <h4>7. Sharing of Information </h4>
            <p>THINGS2DO may disclose your Personal Information in the following ways:</p>
            <ul>
              <li>Disclosure to Government authorities or as required by law<br/>
                THINGS2DO may share your Personal Information with Government and/or statutory authorities in response
                to subpoenas, court orders, or other legal process; to establish or exercise legal rights; to defend
                against legal claims; or as otherwise required by law. THINGS2DO warrants that such information will be
                disclosed only in accordance with applicable laws and regulations.
              </li>
              <li>Disclosure to Acquirers
                THINGS2DO may disclose and/or transfer your Personal Information to an acquirer, assignee or other
                successor entity in connection with a sale, merger, or reorganization of all or substantially all of the
                equity, business or assets of THINGS2DO.
              </li>
              <li>Disclosure to Merchants <br/>
                When you make a transaction on the website/application, THINGS2DO may disclose your Personal Information
                with the merchant, with whom you have entered into the transaction with, to enable the merchant to
                complete your transaction.
              </li>
              <li>Disclosure to Facilitate Payment <br/>
                In order to process your transactions, THINGS2DO may direct you to a payment gateway service provider of
                its own choice, which may have access to the Personal Information provided by you while making such
                payment.
              </li>
              <li>Disclosure to Third Parties <br/>
                THINGS2DO may engage third parties to provide various services to THINGS2DO or collaborate with
                THINGS2DO to host events. If any such third party must have access to your Personal Information in order
                to perform its services, THINGS2DO will require that third party to enter an agreement that binds the
                third party to the use and disclosure restrictions outlined in this Policy. THINGS2DO may also share
                your information with third parties to conduct promotion and/or ad campaigns in case you have explicitly
                chosen to authorise THINGS2DO for sharing your information.
              </li>
            </ul>
            <h4>8. Protection of Information</h4>
            <ul>
              <li>THINGS2DO has taken adequate measures to protect the security of your Personal Information and to
                ensure that your choices for its intended use are honoured. THINGS2DO takes adequate precautions to
                protect your data from loss, misuse, unauthorized access or disclosure, alteration, or destruction.
              </li>
              <li>THINGS2DO assures you that your information is safe and secure. It uses industry standards, and
                physical, technical and administrative security measures to keep your Personal Information confidential
                and secure and THINGS2DO shall not share your Personal Information with third parties, except as
                otherwise provided in this Policy.
              </li>
              <li>At THINGS2DO, data is stored in password-controlled servers with limited access to employees and other
                personnel or consultants on a need-to-know basis.
              </li>
              <li>THINGS2DO uses the encryption technology, which helps to protect your payment information such as your
                credit/debit card number, credit/debit card expiry date, your CVV number etc. Please note that e-mails,
                messaging and means of communication with THINGS2DO are not encrypted, and therefore THINGS2DO strongly
                advises you not to communicate any confidential information through these means.
              </li>
              <li>Access to your online account on the website/application is via Facebook or your email which is
                password protected and this helps to secure your account information. You are solely responsible for
                maintaining the confidentiality of that password. To ensure safety of your Personal Information, you are
                advised against sharing your user name and password with anyone.
              </li>
            </ul>
            <h4>9. Cookies and Other Tracking Technologies</h4>
            <ul>
              <li>The website/application utilizes cookies and other tracking technologies including any proprietary or
                third party tracking services. A cookie is a small text file that may be used, for example, to collect
                information about the website/application activity. Some cookies and other technologies may serve to
                recall Personal and/or Non-Personal Information previously indicated by a website/application/ user.
                Most browsers allow you to control cookies, including whether or not to accept them and how to remove
                them.
              </li>
              <li>You may set most browsers to notify you if you receive a cookie, or you may choose to block cookies
                with your browser, however, if you choose to erase or block your cookies, you shall have to re-enter
                your original user ID and password to gain access to certain parts of the website/application.
              </li>
              <li>Tracking technologies may record information such as internet domain and host names, internet protocol
                (IP) addresses, browser software and operating system types, clickstream patterns, and dates and times
                at which the website/application is accessed. Our use of cookies and other tracking technologies allow
                us to improve our website/application and your experience in using our website/application.
              </li>
            </ul>

            <h4>10. Limitation of Liability</h4>
            <ul>
              <li>THINGS2DO is not responsible for any breach of security or for any actions or inactions of any third
                parties that receive your Personal Information.
              </li>
              <li>Notwithstanding anything contained in this Policy or elsewhere, THINGS2DO shall not be held
                responsible for any loss, damage or misuse of your Personal Information, if such loss, damage or misuse
                is attributable to a Force Majeure Event (as defined below).
              </li>
              <li>A “Force Majeure Event” shall mean any event that is beyond the reasonable control of THINGS2DO and
                shall include, without limitation, sabotage, fire, flood, explosion, acts of God, pandemic/epidemic,
                civil commotion, strikes, lockouts or industrial action of any kind, riots, insurrection, war, acts of
                government, computer hacking, civil disturbances, unauthorised access to computer data and storage
                device, computer crashes, breach of security and encryption, and any other similar events not within the
                control of THINGS2DO and which THINGS2DO is not able to overcome.
              </li>
            </ul>
            <h4>11. Opt-Out</h4>
            <p>You have the option to 'opt-out' of all THINGS2DO’s newsletters and other general e-mail marketing
              communications by way of links provided at the bottom of each mailer. THINGS2DO respects your privacy and
              in the event that you choose to not receive such mailers, it shall take all adequate steps to remove you
              from such lists.</p>
            <h4>12. Changes to this Policy</h4>
            <p>THINGS2DO reserves the right to update, change or modify this Policy at any time. The Policy shall come
              to effect from the date of such update, change or modification.</p>
            <h4>13. Grievance Officer</h4>
            <p>In accordance with the Information Technology Act, 2000 and Rules made thereunder, the name and contact
              details of the Grievance Officer are provided below:<br/>
              Name: Xplorebee PVT LTD<br/>
              Address: Reliable Business Center, 5th Floor, Near Hira Panna Mall, Oshiwara, Andheri (W), Mumbai,
              400102<br/>
              Cell: 18002667666<br/>
              E-mail: <a
                href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;%73%75%70%70%6F%72%74%40%74%68%69%6E%67%73%32%2E%64%6F">support@things2.do</a><br/>
            </p>
            <h4>14. How to Contact Us</h4>
            <p>If you have questions or concerns about this Policy, please contact us at support@things2.do</p>

          </div>
          <!--info-->

        </div>
      </div>

    </div>
  </div>
</section>
<app-footer></app-footer>
